import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './PrivacyPolicy.css'
import { Link } from 'react-router-dom';
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import Cookies from 'js-cookie';


const CookieModal = ({ setCookieAccepted }) => {
    const [modalShow, setModalShow] = useState(false);
    const [expandedAccordion, setExpandedAccordion] = useState(null);
    const [switches, setSwitches] = useState({
        switch1: true,
        switch2: true,
        switch3: true,
        switch4: true,
    });


    const toggleAccordion = (accordionId) => {
        setExpandedAccordion(
            expandedAccordion === accordionId ? null : accordionId
        );
    };
    const handleToggle = (switchName) => {
        setSwitches((prevSwitches) => ({
            ...prevSwitches,
            [switchName]: !prevSwitches[switchName],
        }));
    };


    const handleAcceptCookiesFromChild = () => {
        // Set the cookie in the browser
        Cookies.set('cookieAccepted', 'true', { expires: 30 });

        // Update the parent's state to reflect that cookies are accepted
        setCookieAccepted(true);
        setModalShow(false)
    };

    return (
        <>
            <button className='prefText' onClick={() => setModalShow(true)}>
                Cookie preferences
            </button>

            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='cokkieModalMain'
            >
                <Modal.Header closeButton className='modalherderscross'>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className='privacText'> Privacy Preference Center </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='cookieModalCenter'>
                    <p className='modalText'>
                        To provide you with the best Al Jazeera digital experience possible, we use information about your past and present engagement with our site and services. It includes things like how often you visit our site and what type of content you usually like to view. We use this information to present you with more relevant content, make business and programming decisions, and deliver personalized advertisements for things that you might like. The categories of information we collect are explained below. We recommend that you allow us to use all this information to get the most out of our digital content.
                        <p style={{ marginBottom: "8px" }}></p>
                        Click on the different category headings to find out more and change our default settings according to your preference. You cannot opt-out of our First Party Strictly Necessary Cookies, as they are deployed in order to ensure the proper functioning of our website (such as prompting the cookie banner and remembering your settings, to log into your account, to redirect you when you log out, etc.). For more information about the First and Third Party Cookies used please see our Cookie Policy.
                    </p>
                    <Link to="/client/cookie-policy" target="_blank" className='viewCookieBtn'>
                        View Our Cookie Policy
                    </Link>
                    <div className='consentSection'>
                        <div className='manageText'>Manage Consent Preferences</div>
                        <Accordion
                            expanded={expandedAccordion === 1}
                            onChange={() => toggleAccordion(1)}
                            className='cookieAccordion'
                        >
                            <AccordionSummary
                                expandIcon={
                                    expandedAccordion === 1 ? (
                                        <FaMinus className="minusColor" />
                                    ) : (
                                        <FaPlus className="minusColor" />
                                    )
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='summrAouter'
                            >
                                <div className="cookieHeadung">
                                    Strictly Necessary Cookies
                                </div>
                                <div className='alwaysActiveText'>Always Active</div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="cookieAccordianText"> These cookies are necessary for our website to function, and we can not switch them off in our systems. They provide you with essential services and features available through the websites that you have requested. Some parts of our website will not work if you set your browser to block these cookies. These cookies do not store any personally identifiable information.</div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expandedAccordion === 2}
                            onChange={() => toggleAccordion(2)}
                            className='cookieAccordion'
                        >
                            <AccordionSummary
                                expandIcon={
                                    expandedAccordion === 2 ? (
                                        <FaMinus className="minusColor" />
                                    ) : (
                                        <FaPlus className="minusColor" />
                                    )
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='summrAouter'
                            >
                                <div className="cookieHeadung">
                                    Performance Cookies - First Party
                                </div>
                                <div className='alwaysActiveText'>Always Active</div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="cookieAccordianText">  These first party cookies are necessary and these allow us to understand how you interact with our websites. It helps us to make internal business decisions, like how we can best improve our site design, performance, or stability. We receive this information aggregated and anonymized.</div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expandedAccordion === 3}
                            onChange={() => toggleAccordion(3)}
                            className='cookieAccordion'
                        >
                            <AccordionSummary
                                expandIcon={
                                    expandedAccordion === 3 ? (
                                        <FaMinus className="minusColor" />
                                    ) : (
                                        <FaPlus className="minusColor" />
                                    )
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='summrAouter'
                            >
                                <div className="cookieHeadung">
                                    Performance Cookies - Third Parties
                                </div>
                                <div className={`switch ${switches.switch1 ? 'switch-on' : ''}`} onClick={() => handleToggle('switch1')}>
                                    <div className={`switch-handle ${switches.switch1 ? 'switch-handle-on' : ''}`} />
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="cookieAccordianText">   These cookies allow us to understand how you interact with our websites. It helps us to make internal business decisions, like how we can best improve our site design, performance, or stability. We receive this information aggregated and anonymized.materi</div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expandedAccordion === 4}
                            onChange={() => toggleAccordion(4)}
                            className='cookieAccordion'
                        >
                            <AccordionSummary
                                expandIcon={
                                    expandedAccordion === 4 ? (
                                        <FaMinus className="minusColor" />
                                    ) : (
                                        <FaPlus className="minusColor" />
                                    )
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='summrAouter'
                            >
                                <div className="cookieHeadung">
                                    Functional Cookies
                                </div>
                                <div className={`switch ${switches.switch2 ? 'switch-on' : ''}`} onClick={() => handleToggle('switch2')}>
                                    <div className={`switch-handle ${switches.switch2 ? 'switch-handle-on' : ''}`} />
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="cookieAccordianText"> These cookies enable the website to provide enhanced functionality and personalization. We or our providers whose services we have added to our pages set these cookies. If you do not allow these cookies, some or all of these services may not function properly.</div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expandedAccordion === 5}
                            onChange={() => toggleAccordion(5)}
                            className='cookieAccordion'
                        >
                            <AccordionSummary
                                expandIcon={
                                    expandedAccordion === 5 ? (
                                        <FaMinus className="minusColor" />
                                    ) : (
                                        <FaPlus className="minusColor" />
                                    )
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='summrAouter'
                            >
                                <div className="cookieHeadung">
                                    Targeting Cookies
                                </div>
                                <div className={`switch ${switches.switch3 ? 'switch-on' : ''}`} onClick={() => handleToggle('switch3')}>
                                    <div className={`switch-handle ${switches.switch3 ? 'switch-handle-on' : ''}`} />
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="cookieAccordianText">    These cookies may be set through our site by our advertising partners. Advertisers use this information to build a profile and make advertising messages more relevant to you. They do not store personal information directly but uses unique identifiers of your browser or device.</div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            expanded={expandedAccordion === 6}
                            onChange={() => toggleAccordion(6)}
                            className='cookieAccordion'
                        >
                            <AccordionSummary
                                expandIcon={
                                    expandedAccordion === 6 ? (
                                        <FaMinus className="minusColor" />
                                    ) : (
                                        <FaPlus className="minusColor" />
                                    )
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='summrAouter'
                            >
                                <div className="cookieHeadung">
                                    Social Media Cookies
                                </div>
                                <div className={`switch ${switches.switch4 ? 'switch-on' : ''}`} onClick={() => handleToggle('switch4')}>
                                    <div className={`switch-handle ${switches.switch4 ? 'switch-handle-on' : ''}`} />
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="cookieAccordianText"> These cookies enable you to share or follow the content you find interesting. Our social media partners set these cookies through our websites. This allows us to provide seamless integration between our websites and the social media networks and tools you like.</div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='confirmChoicesBtn' onClick={handleAcceptCookiesFromChild}>Confirm My Choices</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CookieModal
